import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import css from './LandingPage.module.css';
import { ReviewRating } from '../../components';
import Slider from 'react-slick';
import '../../styles/slick/slick.css';
import '../../styles/slick/slick-theme.css';
import Icons from '../../components/Icons/Icons';

import shape1 from '../../assets/landing/testimonial-shape1.png';
import shape2 from '../../assets/landing/testimonial-shape2.png';
function SectionTestimonial() {
  const intl = useIntl();
  const title = intl.formatMessage({ id: 'SectionTestimonial.title' });
  const subtitle = intl.formatMessage({ id: 'SectionTestimonial.subtitle' });
  const testimonials = [
    {
      messageId: 'LandingPage.testimonials.mary.message',
      nameId: 'LandingPage.testimonials.mary.name',
      age: '55',
    },
    {
      messageId: 'LandingPage.testimonials.anna.message',
      nameId: 'LandingPage.testimonials.anna.name',
      age: '45',
    },
    {
      messageId: 'LandingPage.testimonials.laura.message',
      nameId: 'LandingPage.testimonials.laura.name',
      age: '58',
    },
  ];

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: false,
    centerMode: false,
    autoplaySpeed: 2000,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1500, settings: { slidesToShow: 3 } },
      { breakpoint: 1300, settings: { slidesToShow: 3 } },
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 767, settings: { slidesToShow: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className={css.sectionTestimonial}>
      <span className={css.shape1}>
        <img src={shape1} alt="" />
      </span>
      <span className={css.shape2}>
        <img src={shape2} alt="" />
      </span>
      <div className={css.contentWidth}>
        <div className={css.sectionHead}>
          <h2 dangerouslySetInnerHTML={{ __html: title }} />
          <p>{subtitle}</p>
        </div>
        {/* <Slider {...settings}>
        </Slider> */}
        <div className={css.testimonialsWrapper}>
          {testimonials.map((t, index) => (
            <div key={index} className={css.testimonialBlock}>
              <div className={css.testimonialhead}>
                <ReviewRating rating={5} rootClassName={css.ratings} />
                <Icons name="quote" />
              </div>
              <h2>
                <FormattedMessage id={t.messageId} />
              </h2>
              <div className={css.userDetails}>
                <h3>
                  <FormattedMessage id={t.nameId} />, {t.age}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SectionTestimonial;
